import React, { useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { FaCalendar } from 'react-icons/fa';
import moment from 'moment';

const DateRangePicker = ({ onChange }) => {
  const [selectedRange, setSelectedRange] = useState('today');
  const [customStart, setCustomStart] = useState(moment().format('YYYY-MM-DD'));
  const [customEnd, setCustomEnd] = useState(moment().format('YYYY-MM-DD'));

  const presets = [
    { label: 'Today', value: 'today' },
    { label: 'This Week', value: 'week' },
    { label: 'This Month', value: 'month' },
    { label: 'Last Month', value: 'lastMonth' },
    { label: 'Custom Range', value: 'custom' }
  ];

  const handlePresetChange = (preset) => {
    setSelectedRange(preset);
    let start, end;

    switch (preset) {
      case 'today':
        start = end = moment().format('YYYY-MM-DD');
        break;
      case 'week':
        start = moment().startOf('week').format('YYYY-MM-DD');
        end = moment().endOf('week').format('YYYY-MM-DD');
        break;
      case 'month':
        start = moment().startOf('month').format('YYYY-MM-DD');
        end = moment().endOf('month').format('YYYY-MM-DD');
        break;
      case 'lastMonth':
        start = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
        end = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
        break;
      case 'custom':
        start = customStart;
        end = customEnd;
        break;
      default:
        start = end = null;
    }

    onChange(start, end);
  };

  const handleCustomDateChange = (type, value) => {
    let start = customStart;
    let end = customEnd;

    if (type === 'start') {
      start = value;
      setCustomStart(value);
    } else {
      end = value;
      setCustomEnd(value);
    }

    onChange(start, end);
  };

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <Dropdown>
        <Dropdown.Toggle variant="outline-secondary" size="sm">
          <FaCalendar className="me-1" />
          {presets.find(p => p.value === selectedRange)?.label || 'Select Range'}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {presets.map((preset) => (
            <Dropdown.Item
              key={preset.value}
              active={selectedRange === preset.value}
              onClick={() => handlePresetChange(preset.value)}
            >
              {preset.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {selectedRange === 'custom' && (
        <div className="d-flex align-items-center gap-2 flex-wrap" style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
          <small className="text-muted fw-bold" style={{ fontSize: '0.75rem' }}>From:</small>
          <Form.Control
            type="date"
            size="sm"
            value={customStart}
            onChange={(e) => handleCustomDateChange('start', e.target.value)}
            style={{ width: '130px', padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
          />
          <small className="text-muted fw-bold" style={{ fontSize: '0.75rem' }}>To:</small>
          <Form.Control
            type="date"
            size="sm"
            value={customEnd}
            onChange={(e) => handleCustomDateChange('end', e.target.value)}
            style={{ width: '130px', padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
